module.exports = __webpack_public_path__ + "img/15.5abdb712.jpg";